<template>
    <ScreenAdapter>
        <div id="main">
            <Header />
            <Nav />
            <div class="platform-cover" :style="`background:url(${cover}) no-repeat center/cover`"></div>
            <div class="eol-main-container">
                <div class="submenu-left">
                    <div class="submenu-title">专业群思政</div>
                    <div class="submenu-item" :class="{ active: zsiActiveTab == tab.category_id }"
                        v-for="(tab, index) in zsiTabs" :key="index" @click="switchZsiTab(tab.category_id)">{{ tab.name
                        }}
                    </div>
                </div>
                <div class="info-right">
                    <template v-if="szzyData && szzyData.length > 0">
                        <div v-if="zsiActiveTab == alumniId" class="article-list">
                            <div class="article-items" v-for="(item, index) in szzyData" :key="index"
                                @click="jumpDetail(item)">
                                <div v-if="item.cover_url" class="lfet-imgs-box">
                                    <div class="cover-img" :style="`background-image: url('${item.cover_url}');`"></div>
                                </div>

                                <div class="right-brief-box">
                                    <div class="top-title" target="_blank">{{ item.title }}</div>
                                    <div class="top-brief">{{ item.description }}</div>
                                    <div class="top-source">
                                        <span v-if="item.publish_time" format-type="YYYY-MM-DD">{{
                                            item.publish_time.split(' ')[0] }}</span>
                                        <span v-if="item.source" data-source="公共教育学院">来源：{{ item.source }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="zsiActiveTab == szzyId" class="classic-list">
                            <div v-for="(item, index) in szzyData" :key="index" class="classic-item"
                                @click="jumpDetail(item)">
                                <div class="img-top">
                                    <div class="imgs-bg" :style="`background-image: url('${item.cover_url}');`"></div>
                                </div>
                                <div class="txt-bottom">
                                    <div class="title">{{ item.title }}</div>
                                    <div class="second">
                                        <span v-if="item.publish_time">{{ item.publish_time.split(' ')[0] }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="sub-visibility"></div>
                            <div class="sub-visibility"></div>
                            <div class="sub-visibility"></div>
                        </div>


                        <a-pagination v-model="page" :show-total="(total) => `共${total}条`" :default-current="1"
                            :pageSize="size" :total="total" @change="onPageChange" />

                    </template>
                    <div v-else class="noData">暂无数据</div>
                </div>
            </div>
            <Footer />
        </div>
    </ScreenAdapter>
</template>

<script>
import Header from "@/components/Hzvtc/Header.vue"
import Nav from "@/components/Hzvtc/Nav.vue"
import Footer from "@/components/Hzvtc/Footer.vue"
import services from '../../../config/services'
import ScreenAdapter from "@/components/ScreenAdapter.vue"
export default {
    data() {
        // 分类 category_id 区分环境：生产环境 优秀校友-721、思政资源-722；测试/开发环境 优秀校友-686、思政资源-687
        const isPro = process.env.NODE_ENV == 'production' && process.env.VUE_APP_FLAG === 'pro'
        const alumniId = isPro ? '721' : '686'
        const szzyId = isPro ? '722' : '687'
        const siteId = isPro ? 7 : 3
        return {
            cover: require("../../../assets/hzvtc/cover/zyqsz.jpg"),
            school_code: services.HZ_CODE,
            total: 0,
            size: 12,
            page: 1,
            szzyData: [],
            siteId,
            alumniId,
            szzyId,
            zsiActiveTab: alumniId,
            // 专业群思政两个分类 Tab
            zsiTabs: [
                { name: "优秀校友", category_id: alumniId },
                { name: "思政资源", category_id: szzyId },
            ],
        }
    },
    components: {
        Header,
        Nav,
        Footer,
        ScreenAdapter
    },
    async mounted() {
        this.zsiActiveTab = this.$route.query.id ? this.$route.query.id : this.alumniId
        this.getListData()
    },
    methods: {
        onPageChange(val) {
            this.page = val
            this.getListData()
        },
        async getListData() {
            // sub_type: '1' 1带图 2不带图
            let params = { page: this.page, length: this.size, site_id: this.siteId, category_id: this.zsiActiveTab, order_by: 'weight desc,publish_time desc' }
            // 专业群思政 - 思政资源
            await services.getRmtNewsList(params).then(res => {
                if (res.code == '0000') {
                    this.szzyData = res.data.items
                    this.total = res.data.total
                } else {
                    this.szzyData = []
                    this.total = 0
                }
            })
        },
        // 切换分类
        switchZsiTab(val) {
            this.zsiActiveTab = val
            this.page = 1
            this.total = 0
            this.getListData()
        },
        // 跳转到详情
        jumpDetail(item) {
            if (!item) return
            if (item.type == 3 && item.url) {
                window.open(item.url, "_blank",);
            } else {
                window.open(`/center/${this.school_code}/hzvtc/article?id=${item.id}&key=zyqsz`, "_blank")
            }
        },
    },
}
</script>

<style lang="less" scoped>
#main {
    background-color: #FFFFFF;
}

.platform-cover {
    width: 100%;
    height: 510px;
}

.eol-main-container {
    background-color: #FFFFFF;
    width: 1400px;
    margin: 37px auto;
    display: flex;

    .submenu-left {
        width: 260px;

        .submenu-title {
            width: 100%;
            display: block;
            padding-bottom: 39px;
            margin-bottom: 3px;
            text-align: center;
            font-weight: bold;
            border-bottom: 4px solid #A40000;
            font-size: 30px;
            font-style: normal;
            background: -webkit-linear-gradient(90deg, #B61E2A 0%, #EF350A 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            color: #A40000;
            /* 备用颜色，以防WebKit不兼容 */
        }

        .submenu-item {
            width: 100%;
            height: 80px;
            display: block;
            line-height: 80px;
            text-align: center;
            border-bottom: 1px solid #A40000;
            cursor: pointer;
            font-weight: bold;
            font-size: 22px;
            color: #333333;
            position: relative;

            &.active {
                background: #A40000;
                color: #FFFFFF;
            }
        }
    }

    .info-right {
        flex: 1;
        margin-left: 60px;
        overflow: hidden;

        .noData {
            font-size: 14px;
            width: 100%;
            padding: 30px 0;
            text-align: center;
            color: #999999;
        }

        .article-list {
            .article-items {
                display: flex;
                padding: 30px 0;
                border-bottom: 1px dotted #DEDDDA;
                cursor: pointer;

                &:nth-child(1) {
                    padding: 0 0 30px;
                }

                .lfet-imgs-box {
                    width: 332px;
            height: 187px;
                    margin-right: 36px;
                    position: relative;
                    overflow: hidden;
                    flex-shrink: 0;

                    .cover-img {
                        width: 100%;
                        height: 100%;
                        background-position: center;
                        background-repeat: no-repeat;
                        background-size: cover;
                        transition: all 0.3s;
                    }
                }

                .right-brief-box {
                    flex: 1;

                    .top-title {
                        font-weight: bold;
                        font-weight: bold;
                        font-size: 17px;
                        color: #333333;
                        line-height: 28px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        margin-bottom: 25px;
                    }

                    .top-source {
                        font-size: 14px;
                        color: #A6ACB5;
                        line-height: 26px;

                        span:not(:last-child) {
                            margin-right: 40px;
                        }
                    }

                    .top-brief {
                        font-size: 14px;
                        color: #999999;
                        line-height: 26px;
                        text-align: left;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        margin-bottom: 36px;
                    }

                }

                &:hover .right-brief-box .top-title {
                    color: #A40000;
                }

                &:hover .lfet-imgs-box .cover-img {
                    transform: scale(1.1);
                }
            }
        }
    }

    .classic-list {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        text-align: left;
    }

    .classic-item {
        width: 332px;
        background: #fff;
        overflow: hidden;
        cursor: pointer;
        margin-bottom: 45px;
        flex-shrink: 0;

        &:hover {
            box-shadow: 1px 2px 7px #ececec;
            transition: 0.3s box-shadow;

            .txt-bottom .title {
                color: #dc3034;
            }
        }

        .img-top {
            width: 332px;
            height: 187px;
            overflow: hidden;
            position: relative;

            .imgs-bg {
                position: relative;
                z-index: 1;
                width: 100%;
                height: 100%;
                margin: 0 auto;
                transition: all 0.4s;
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center;
            }
        }

        &:hover .img-top .imgs-bg {
            transform: scale(1.1);
        }

        .txt-bottom {
            padding: 25px 20px 15px;
            width: 100%;
            box-sizing: border-box;
            border: 1px solid #DEDDDA;
            border-top: none;

            .title {
                font-weight: bold;
                font-size: 17px;
                line-height: 28px;
                color: #333333;
                height: 56px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }

            .second {
                font-size: 14px;
                color: #A6ACB5;
                margin: 10px 0;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

            }

        }
    }

    .classic-list .sub-visibility {
        flex: 0 0 332px;
        display: inline-block;
        overflow: visible;
    }
}

:deep .ant-pagination {
    text-align: center;
    padding: 20px 0 0;

    .ant-pagination-item {
        cursor: pointer;
    }

    .ant-pagination-item:focus,
    .ant-pagination-item-active {
        border-color: #A40000;
        background-color: #A40000 !important;

        a {
            color: #fff !important;
        }
    }

    .ant-pagination-item:hover {
        border-color: #A40000 !important;
        background-color: #FFFFFF !important;
        transition: all 0.3s;
    }

    .ant-pagination-item:hover a {
        color: #A40000 !important;
    }
}
</style>